export class RoundedCursor {
	constructor() {
		this.containers = document.querySelectorAll('[data-cursor]');
	}

	init() {
		this.containers.forEach((container) => {
			const list = container.querySelector('ul');

			list.addEventListener('mouseenter', () => {
				let size = 0;

				const sizeInterval = setInterval(() => {
					container.style.setProperty('--size', `${size}px`);
					size++;

					if (size >= 50) clearInterval(sizeInterval);
				}, 2);
			});
			list.addEventListener('mouseleave', () => {
				let size = 50;

				const sizeInterval = setInterval(() => {
					container.style.setProperty('--size', `${size}px`);
					size--;

					if (size < 0) clearInterval(sizeInterval);
				}, 2);
			});
			list.addEventListener('mousemove', (e) => {
				this.move(container, e);
			});
		});
	}

	move(container, e) {
		//const cursor = container.querySelector('.roundedCursor');
		const x = e.clientX;
		const y = e.clientY;
		const rect = container.getBoundingClientRect();
		const left = rect.left;
		const top = rect.top;
		const cursorX = x - left;
		const cursorY = y - top;

		container.style.setProperty('--x-position', cursorX + 'px');
		container.style.setProperty('--y-position', cursorY + 'px');
		//
		//constainer.style.setProperty('--cursor-x', cursorX);
		/*	cursor.style.borderRadius = cursorBorderRadius;
		cursor.style.transform = cursorTransform;

		cursor.style.top = '0';
		cursor.style.left = '0';
		cursor.style.pointerEvents = 'none';*/
	}
}
